
import ResidentsPage from "../pages/RESIDENTSPage";
import ADMIN from "../pages/ADMIN";
import SECURITYPage from "../pages/SECURITYPage";
import SmartMeterPage from "../pages/SmartMeterPage";
import MarketplacePage from "../pages/MarketplacePage";
import BLOGPages from "../pages/BLOGPages";
import FAQPage from "../pages/FAQPage";
import ABOUTPage from "../pages/ABOUTPage";
import PrivacyPage from "../pages/PrivacyPage";
import TermsPage from "../pages/TermsPage";
import BlogIndividualPage from "../pages/BlogIndividualPage";
import ContactPage from "../pages/ContactPage";
import PageNotFound from "../pages/PageNotFound";
import GetStartedPage from "../pages/GetStartedPage";
import ResidentsHowItWorks from "../pages/HowItWorksPages/ResidentsHowItWorks";
import Referrer from "../pages/Referrer";
import ReferralFormPage from "../pages/ReferralFormPage";
import OnboardingPage from "../pages/OnboardingPage";
import ReferCommunityPage from "../pages/ReferCommunityPage";
import AdminHowItWorks from "../pages/HowItWorksPages/AdminHowItWorks";
import SecurityHowItWorks from "../pages/HowItWorksPages/SecurityHowItWorks";
import MobileUpdatePage from "../pages/mobile-updates/VisitorsBooking.jsx";
import BillsAndUtilityPage from "../pages/mobile-updates/BillsandUtility";
import IssuesReportingPage from "../pages/mobile-updates/IssuesReporting";
import AmenitiesBookingPage from "../pages/mobile-updates/AmenitiesBooking";
import EmergencyReportingPage from "../pages/mobile-updates/EmergencyReporting";
import DashboardPage from "../pages/mobile-updates/DashboardPage";
import VerifyEmailPage from "../pages/VerifyEmailPage";
import VirtualIDPage from "../pages/mobile-updates/VirtualIDPage";
import NFCPage from "../pages/mobile-updates/NFCPage.jsx";
import NoticesPage from "../pages/mobile-updates/NoticesPage";

import Rema from "../pages/Rema/index.jsx";
import EVENTS from "../pages/EVENTS.jsx";
import RSVPManagerLoginPage from "../pages/RSVPManagerLoginPage.jsx";
import RSVPPage from "../pages/RSVPPage.jsx";
import PendingRSVPPage from "../pages/PendingRSVPPage.jsx";
import ApprovedGuestPage from "../pages/ApprovedGuestPage.jsx";
import RSVPDetailsPage from "../pages/RSVPDetailsPage.jsx";
import GuestsList from "../pages/GuestsList.jsx";
import REMAPage from "../pages/REMAPage.jsx";
import { } from "../components/REMA/constants";
import { REMA_REGISTRATION_PAGE_ROUTE, REMA_LANDING_PAGE_URL } from "../components/REMA/constants";





const APP_ROUTES = [
    {
        path: "/",
        component: <Rema />
    },
    {
        path: "/visitors-booking-is-disabled",
        component: <MobileUpdatePage />
    },
    {
        path: "/emergency-reporting-is-disabled",
        component: <EmergencyReportingPage />,
    },
    {
        path: "/amenities-booking-is-disabled",
        component: <AmenitiesBookingPage />
    },
    {
        path: "/issues-reporting-is-disabled",
        component: <IssuesReportingPage />
    },
    {
        path: "/dashboard-is-disabled",
        component: <DashboardPage />
    },
    {
        path: "/virtual-id-is-disabled",
        component: <VirtualIDPage />
    },
    {
        path: "/nfc-is-disabled",
        component: <NFCPage />
    },
    {
        path: "/notices-is-disabled",
        component: <NoticesPage />
    },
    {
        path: "/bills-and-utility-is-disabled",
        component: <BillsAndUtilityPage />
    },
    {
        path: "/residents",
        component: <ResidentsPage />
    },
    {
        path: "/admin",
        component: <ADMIN />
    },
    {
        path: "/security",
        component: <SECURITYPage />
    },
    {
        path: "/meters",
        component: <SmartMeterPage />
    },
    {
        path: "/marketplace",
        component: <MarketplacePage />
    },
    {
        path: "/blog",
        component: <BLOGPages />
    },
    {
        path: "/faq",
        component: <FAQPage />
    },
    {
        path: "/about-us",
        component: <ABOUTPage />
    },
    {
        path: "/contact-us",
        component: <ContactPage />
    },
    {
        path: "/privacy-policy",
        component: <PrivacyPage />
    },
    {
        path: "/terms-and-condition",
        component: <TermsPage />
    },
    {
        path: "/get-started",
        component: <GetStartedPage />
    },
    {
        path: "/switch",
        component: <OnboardingPage />
    },
    {
        path: "/how-it-works-for-residents",
        component: <ResidentsHowItWorks />
    },
    {
        path: "/how-it-works-for-admins",
        component: <AdminHowItWorks />
    },
    {
        path: "/how-it-works-for-security",
        component: <SecurityHowItWorks />
    },
    {
        path: "/verify-email",
        component: <VerifyEmailPage />
    },
    {
        path: "/referrer",
        component: <Referrer />
    },
    {
        path: "/refer-community",
        component: <ReferCommunityPage />
    },
    {
        path: "/signup-referral",
        component: <ReferralFormPage />
    },
    {
        path: "/onboard",
        component: <OnboardingPage />
    },
    {
        path: "/:slug",
        component: <BlogIndividualPage />
    },

    {
        path: REMA_LANDING_PAGE_URL,
        component: <Rema />
    },
    {
        path: "/events",
        component: <EVENTS />
    },
    {
        path: "/rsvp-auth",
        component: <RSVPManagerLoginPage />
    },
    {
        path: "/rsvp",
        component: <RSVPPage />
    },
    {
        path: REMA_REGISTRATION_PAGE_ROUTE,
        component: <REMAPage />
    },
    {
        path: "/pending-rsvp",
        component: <PendingRSVPPage />,
        requireAuth: true
    },

    {
        path: "/approved-guests",
        component: <ApprovedGuestPage />,
        requireAuth: true
    },
    {
        path: "/rsvp-details",
        component: <RSVPDetailsPage />,
        requireAuth: true
    },
    {
        path: "/guests",
        component: <GuestsList />,
        requireAuth: true
    },

    //   THIS SHOULD ALWAYS BE LAST IN THE ARRAY
    {
        path: "/404",
        component: <PageNotFound />
    },
    {
        path: "*",
        component: <PageNotFound />
    },
];

export default APP_ROUTES;
